var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDragIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.972,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.12602 1.58374C7.11621 1.56177 7.71615 2.03182 7.92582 2.9939C7.90114 4.26779 7.25173 4.85534 5.97758 4.7566C4.93065 4.38847 4.55336 3.66486 4.84574 2.5857C5.10532 2.03515 5.53208 1.70117 6.12602 1.58374Z",
    fill: "#D1D4DF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.972,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.4716 1.58398C13.7445 1.62603 14.3321 2.28163 14.2343 3.55078C13.8662 4.59771 13.1426 4.975 12.0634 4.68262C11.3585 4.34321 11.0307 3.78038 11.08 2.99414C11.2289 2.2082 11.6928 1.73814 12.4716 1.58398Z",
    fill: "#D1D4DF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.974,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.05218 7.92958C6.97324 7.85585 7.58554 8.25169 7.8891 9.11708C8.04963 10.0641 7.68474 10.7135 6.79437 11.0653C5.76024 11.2567 5.08608 10.8547 4.77191 9.85927C4.66147 8.8516 5.08823 8.20839 6.05218 7.92958Z",
    fill: "#D1D4DF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.974,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.3975 7.9297C13.3504 7.86301 13.9627 8.28357 14.2344 9.19142C14.352 10.1986 13.9253 10.8356 12.9541 11.1025C12.0323 11.1944 11.4199 10.8047 11.1172 9.9336C10.967 8.89116 11.3938 8.22319 12.3975 7.9297Z",
    fill: "#D1D4DF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.972,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.97792 14.2751C6.86358 14.1641 7.48827 14.5105 7.85195 15.3141C8.09598 16.2794 7.76819 16.9659 6.86855 17.3737C6.18737 17.5699 5.59982 17.4153 5.10585 16.9098C4.7099 16.3398 4.64803 15.7336 4.92031 15.0915C5.16248 14.6692 5.51502 14.3971 5.97792 14.2751Z",
    fill: "#D1D4DF"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.972,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.3235 14.2755C13.2168 14.1742 13.8415 14.5329 14.1975 15.3517C14.4094 16.2948 14.0816 16.9689 13.2141 17.3742C12.2489 17.6182 11.5623 17.2904 11.1545 16.3908C10.9584 15.7096 11.113 15.122 11.6184 14.6281C11.8365 14.4695 12.0716 14.352 12.3235 14.2755Z",
    fill: "#D1D4DF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDragIcon);
export default __webpack_public_path__ + "static/media/dragIcon.2ae9452c34afb3f2ca60b65562257ff2.svg";
export { ForwardRef as ReactComponent };